/* PawDent — פוטר: קבוצות הקישורים סגורות במובייל ופתוחות תמיד בדסקטופ. */
(function () {
  'use strict';

  var mq = window.matchMedia('(min-width: 750px)');

  function apply() {
    document.querySelectorAll('[data-pft-acc]').forEach(function (group) {
      group.open = mq.matches;
    });
  }

  if (document.readyState !== 'loading') apply();
  else document.addEventListener('DOMContentLoaded', apply);

  if (mq.addEventListener) mq.addEventListener('change', apply);
  else mq.addListener(apply);

  document.addEventListener('shopify:section:load', apply);
})();
